import { StakeholderSubjectType } from "@wingspanhq/wingspan-api-sdk";
import React, { useMemo } from "react";
import { queriesStakeholders } from "@query";
import { useSession } from "@hooks/useSession";
import { FormStakeholder } from "../components/FormStakeholder";
import { Layout } from "../../../shared/components/Layout";
import { routeHelpersAccountStakeholders } from "../paths";

export const RouteAddStakeholder: React.FC = () => {
  const { accountId } = useSession();
  const goToList = routeHelpersAccountStakeholders.useGoTo();

  const [createStakeholder, createStakeholderMeta] =
    queriesStakeholders.createAccountStakeholder.useMutation();

  const goBack = useMemo(() => () => goToList(), [goToList]);

  return (
    <Layout title="Add team member" onBack={goBack} onClose={goBack}>
      <FormStakeholder
        title="Add team member"
        submitButtonLabel="Add member"
        loading={createStakeholderMeta.isLoading}
        error={createStakeholderMeta.error}
        onBack={goBack}
        onSubmit={async data => {
          await createStakeholder(
            {
              accountId,
              stakeholderCreate: {
                subjectType: StakeholderSubjectType.PERSON,
                email: data.email,
                roleId: data.roleId
              }
            },
            { throwOnError: true }
          );

          goBack();
        }}
        defaultValues={{
          email: "",
          roleId: ""
        }}
      />
    </Layout>
  );
};
